import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { ArrowRightFill, CheckmarkCircleFill } from '@lyearn/icons';
import { cn } from '@lyearn/style';
import { Button, Stack, Typography } from '@lyearn/ui';
import { typography } from '@/consts/typography';

import { SurveyCompleteContentProps } from './types';

const SurveyCompleteContentMobile: React.FC<SurveyCompleteContentProps> = (props) => {
  const { className, onBack, onNext, backActionText } = props;
  const { t } = useTranslation('SurveyEditor');

  return (
    <>
      <Stack
        alignItems="center"
        className={cn('flex-1 pb-56', className)}
        direction="col"
        justifyContent="center">
        <CheckmarkCircleFill className="mb-28 h-40 w-40" fillColorToken="icon-success" />
        <Typography color="text-text-primary" variant="heading-s">
          {t('SurveyEditor:Completion.CompletionHeadline')}
        </Typography>
        <Typography className="mt-8" color="text-text-paragraph" variant="body-short-01">
          {t('SurveyEditor:Completion.CompletionDescription')}
        </Typography>
      </Stack>
      <Stack className="self-center px-20 w-full mt-32 pb-36" gapX={8} justifyContent="center">
        <Button
          disableFocusRipple
          shape="pill"
          typography={typography}
          variant="outlined"
          onClick={onBack}>
          {backActionText}
        </Button>
        {onNext && (
          <Button EndIcon={ArrowRightFill} typography={typography} onClick={onNext}>
            {t('Common:NextContent')}
          </Button>
        )}
      </Stack>
    </>
  );
};

export default React.memo(SurveyCompleteContentMobile);
